import { 
    addDataFactory,
    IPlotData as ICorePlotData, 
    createPlotData as createCorePlotData, 
    ISourceData as ICoreSourceData, 
    createData as createCoreData,
} from "../../core";
import { ageRanges } from "./viewModel";
import { IDashboardSharedViewModel, KeyedDimension } from "../../common/plotdata/viewModel"

export { ageRanges };

/**
 * Sort asc
 * @param a 
 * @param b 
 */
export const sort = (_: ISourceData, a: string, b: string): number => {
    //Alphabetically by key (name)
    return ((a > b) ? -1 : ((a > b) ? 1 : 0));
};

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export type ISourceData = ICoreSourceData;

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
export const createData = createCoreData;



/**
 * 
 * @param age Convert raw age to enum
 */
export const toAgeRange = (age: number): KeyedDimension => {
    if (age === undefined || age === null || age === 999 || age < 0) {
        return ageRanges.unknown;
    }

    if (age > 14 && age < 19) return ageRanges.lt19;
    else if (age > 18 && age < 26) return ageRanges.lt26;
    else ageRanges.ltother;

    return ageRanges.unknown;
};

/**
 * Accumulate the vm value into the source data object.
 * 
 * @param vm source view model
 * @param into data object to accumulate into
 */
export const addData = addDataFactory((vm: IDashboardSharedViewModel) => vm.ageRange.name);
